import { FixedDiscountRuleForm } from "@refund/register-fixed-discount-rules/register/components";
import { useRefundRule } from "@refund/query-fixed-discount-rules/hooks";
import { IRefundRules as IRegisterRefundRules } from "@refund/register-fixed-discount-rules/register/hooks";
import { useParams } from "react-router-dom";
import { ApiLoadingSpinner, ApiRequestError, BreadCrumb, Title } from "@funcional/react-ui";
import { useHistory } from "react-router-dom";
import { useStates } from "@refund/register-fixed-discount-rules/register/hooks";
import { IUpdateRefundRulesInputType } from "../contracts/";
import { useUpdateFixedDiscountRule } from "../hooks";

export default function EditFixedDiscountRulePage() {
  const { ruleId }: { ruleId: string } = useParams();
  const history = useHistory();
  useStates();
  const { isLoading, isSuccess, mutateAsync } = useUpdateFixedDiscountRule();

  const { status, data, error, isFetching, refetch } = useRefundRule(
    isNaN(parseInt(ruleId)) ? '' as any as number : parseInt(ruleId)
  );

  const onSubmit = async (input: any) => {
    try {
      const getStartDate = (toUpdate, input) => {
        toUpdate.startDate = new Date(input)
        return toUpdate
      }
      const getEndDate = (toUpdate, input) => {
        toUpdate.endDate = new Date(input)
        return toUpdate
      }
      const getDiscountRanges = (toUpdate, input) => {
        toUpdate.discountRanges = input.map(range => {
          return {
            discount: parseFloat(range.discount),
            discountRefund: parseFloat(range.discountRefund)
          }
        }
        )
        return toUpdate
      }
      const getHeadquarters = (toUpdate, input) => {
        toUpdate.headquarters = input.map(headquarter => parseInt(headquarter))
        return toUpdate
      }
      const getStates = (toUpdate, input) => {
        // a rule implemented in the backend considers that it is 
        // receiving all the states when we send an empty array
        if (input.length === 26) {
          toUpdate.states = []
        } else {
          toUpdate.states = input.map(state => parseInt(state))
        }
        return toUpdate
      }
      const getFormulaAttributes = (toUpdate, input) => {
        if (input instanceof Array) input = JSON.stringify(input)

        if (input === '["INDUSTRY_PRICE","MULTIPLICATION","DISCOUNT","MULTIPLICATION","SALE_QUANTITY"]' ||
          input === '["UNIT_PRICE","MULTIPLICATION","DISCOUNT","MULTIPLICATION","SALE_QUANTITY"]') {
          toUpdate.formulaAttributes = JSON.parse(input)
          return toUpdate;
        }
        throw new Error('Valor inválido para a fórmula a ser considerada no cálculo de ressarcimento, cheque os campos e tente novamente.')
      }
      const prepareDataFromInput = (input) => {
        let toUpdateData = {
          refundRulesId: parseInt(input.ruleId),
        } as IUpdateRefundRulesInputType;
        toUpdateData = getStartDate(toUpdateData, input.startDate)
        toUpdateData = getEndDate(toUpdateData, input.endDate)
        toUpdateData = getDiscountRanges(toUpdateData, input.ranges)
        toUpdateData = getHeadquarters(toUpdateData, input.headquartersId)
        toUpdateData = getStates(toUpdateData, input.statesId)
        toUpdateData = getFormulaAttributes(toUpdateData, input.formulaAttributes)
        return toUpdateData
      }

      const toUpdateData = prepareDataFromInput(input)
      const record: IRegisterRefundRules = await mutateAsync(toUpdateData);
      if (record) {
        window.alert(
          "Regra de desconto fixo atualizada com sucesso!"
        );
        return history.push(
          `/refund/fixed-discount-rule/`
        );
      }
    } catch (error) {
      let message = ''
      if (error instanceof Error) {
        const startIndex = error.message.indexOf('### ERROR ###');
        const endIndex = error.message.indexOf(':', startIndex + '### ERROR ###'.length);
        const capitalizeFirstLetter = (string: string): string => string.charAt(0).toUpperCase() + string.slice(1);
        if (startIndex > -1 && endIndex > -1) {
          let serverMessage = `${error.message.substring(startIndex + '### ERROR ###'.length, endIndex).toLowerCase()}`
          message = `Retorno do servidor:${capitalizeFirstLetter(serverMessage)}`
        }
      }
      window.alert(
        `Não foi possível atualizar o registro, tente novamente mais tarde. Caso o problema persista entre em contato com o administrador do sistema.\n\n${message}`
      );
    }
  };

  return (<>
    {status === "loading" ? (
      <ApiLoadingSpinner />
    ) : (status === "error" || !data) ? (
      data ? (
        <div>
          <p>Ocorreu um erro na obtenção dos dados relacionados a essa regra.</p>
          <p>Tente novamente mais tarde, caso o problema persista entre em contato com o administrador do sistema.</p>
        </div>
      ) : (
        <ApiRequestError error={error} />
      )
    ) : Object.values(data).length > 0 ? (
      <div>
        <Title>Editar Regra de Desconto Fixo</Title>

        <BreadCrumb
          items={[
            {
              path: "/refund/fixed-discount-rule",
              label: "Consultar Regras de Desconto Fixo"
            },
            {
              label: "Editar regra de desconto fixo"
            },
            {
              label: ruleId,
            },
          ]}
        />
        <FixedDiscountRuleForm
          onSubmit={onSubmit}
          editMode
          defaults={data}
        />
      </div>
    ) : (
      <div>Nenhuma regra de desconto fixo foi encontrada para esse ID.</div>
    )}
  </>);
}
